import VueRouter from 'vue-router'
import ActivateAccount from 'components/ActivateAccount'
import ActivateAccountForEvent from 'components/ActivateAccountForEvent'
import ActivateAccountForShowroomPrivate from 'components/ActivateAccountForShowroomPrivate'
import RegisterPage from 'modules/auth/RegisterPage.vue'
import RegisterOrganizationPage from 'pages/RegisterOrganizationPage.vue'
import ChangePasswordPage from 'modules/auth/ChangePasswordPage.vue'
import ForgotPasswordPage from 'modules/auth/ForgotPasswordPage.vue'
import ResetPasswordPage from 'modules/auth/ResetPasswordPage.vue'
import SetNewPasswordPage from 'pages/SetNewPasswordPage.vue'
import LoginPage from 'pages/auth/LoginPage'
import LoginWithPasscodePage from '@/modules/auth/LoginWithPasscodePage'
import LogoutPage from 'modules/auth/LogoutPage.vue'
import ConfirmAgreements from '@/modules/auth/ConfirmAgreements'
import CeeChallenge from 'modules/cee-challenge/CeeChallenge.vue'
import CeeChallengeTerms from 'modules/cee-challenge/Terms.vue'
import PerfectPitch from 'modules/home/PerfectPitch.vue'
import EventPage from 'modules/events/EventPage.vue'
import EventPagePasscode from 'modules/events/EventPagePasscode.vue'
import OrganizationPage from 'modules/organizations/OrganizationPage/OrganizationPage'
import RegisterStartup from 'modules/organizations/RegisterStartup'
import PrivacyPolicyPage from 'modules/legal-pages/PrivacyPolicyPage.vue'
import TermsPage from 'modules/legal-pages/TermsPage.vue'
import Error404 from 'modules/errors/Error404.vue'
import SubscribePage from 'modules/auth/SubscribePage.vue'

import HomeRedirect from 'pages/HomeRedirect.vue'

import PublicStartupProfile from '@/modules/startup-profile/PublicStartupProfile'
import PrivateStartupProfile from '@/modules/startup-profile/PrivateStartupProfile'

import ApiDocsPage from 'modules/api-docs/ApiDocsPage.vue'
import adminRoutes from 'modules/admin/routes'

import dashboardRoutes from '@/modules/dashboard/routes'

const PublicInvestorProfile = () =>
  import(
    /* webpackChunkName: admin */ '@/modules/investor-profile/PublicInvestorProfile'
  )
const InvestorOverview = () =>
  import(/* webpackChunkName: admin */ '@/modules/investor-profile/Overview')
const InvestorTeam = () =>
  import(/* webpackChunkName: admin */ '@/modules/investor-profile/Team')

const routes = [
  {
    path: '/cee-startup-challenge',
    name: 'cee-startup-challenge',
    component: CeeChallenge,
    meta: { title: 'CEE Startup Challenge' },
  },
  {
    path: '/cee-challenge',
    name: 'cee-challenge',
    component: CeeChallenge,
    meta: { title: 'CEE Startup Challenge' },
  },
  {
    path: '/cee-startup-challenge/terms-of-participation',
    name: 'terms-of-participation',
    component: CeeChallengeTerms,
    meta: { title: 'Terms of participation' },
  },
  {
    path: '/challenge-terms-of-participation',
    name: 'challenge-terms-of-participation',
    component: CeeChallengeTerms,
    meta: { title: 'Terms of participation' },
  },
  { path: '', name: 'home', component: HomeRedirect },
  {
    path: '/perfect-pitch',
    name: 'perfectPitchEbook',
    component: PerfectPitch,
  },
  { path: '/subscribe', name: 'subscribePage', component: SubscribePage },
  ...adminRoutes,
  ...dashboardRoutes,
  {
    path: '/s/:slug/:startupId/:linkId',
    name: 'privateStartupProfileWithSlug',
    component: PrivateStartupProfile,
    props: true,
  },
  {
    path: '/s/:startupId/:linkId',
    name: 'privateStartupProfile',
    component: PrivateStartupProfile,
    props: true,
  },
  {
    path: '/s/:slug',
    name: 'publicStartupProfile',
    component: PublicStartupProfile,
    props: true,
  },
  {
    path: '/investors/:id',
    component: PublicInvestorProfile,
    props: true,
    children: [
      { path: '', component: InvestorOverview, name: 'publicInvestorProfile' },
      {
        path: 'team',
        component: InvestorTeam,
        name: 'publicInvestorProfileTeam',
      },
    ],
  },
  {
    path: '/activate-for-event/:userId/:eventId/:token',
    name: 'activateAccountForEvent',
    component: ActivateAccountForEvent,
    props: true,
  },
  {
    path: '/activate-for-showroom/:userId/:eventId/:token/:privateToken',
    name: 'activateAccountForShowroomPrivate',
    component: ActivateAccountForShowroomPrivate,
    props: true,
  },
  {
    path: '/activate/:userId/:activationToken',
    name: 'activateAccount',
    component: ActivateAccount,
  },

  {
    path: '/org/:orgId',
    name: 'organizationPage',
    component: OrganizationPage,
    props: true,
    children: [
      {
        path: 'register-startup',
        name: 'organizationPageRegisterStartupLegacy',
        props: true,
        component: RegisterStartup,
      },
      {
        path: ':programId/register-startup',
        name: 'organizationPageRegisterStartup',
        props: true,
        component: RegisterStartup,
      },
    ],
  },

  {
    path: '/auth/passcode-login',
    name: 'loginWithPasscodePage',
    component: LoginWithPasscodePage,
  },

  { path: '/e/:slug', name: 'eventPage', component: EventPage },
  {
    path: '/e/:slug/passcode',
    name: 'eventPagePasscode',
    component: EventPagePasscode,
  },
  { path: '/register', name: 'register', component: RegisterPage },
  {
    path: '/register-org',
    name: 'registerOrganization',
    component: RegisterOrganizationPage,
  },
  { path: '/login', name: 'login', component: LoginPage, props: true },
  { path: '/logout', name: 'logout', component: LogoutPage },
  {
    path: '/confirm-agreements',
    name: 'confirm-agreements',
    component: ConfirmAgreements,
  },
  {
    path: '/change-password',
    name: 'changePasswordPage',
    component: ChangePasswordPage,
  },
  {
    path: '/set-new-password',
    name: 'setNewPasswordPage',
    component: SetNewPasswordPage,
  },
  {
    path: '/forgot-password',
    name: 'forgotPasswordPage',
    component: ForgotPasswordPage,
  },
  {
    path: '/auth/reset-password/:userId/:token',
    name: 'resetPasswordPage',
    component: ResetPasswordPage,
    props: true,
  },

  { path: '/terms', name: 'termsPage', component: TermsPage },
  // privacy policy is deprecated. For now we would use PDF file
  // {path: '/privacy-policy', name: 'privacyPolicyPage', component: PrivacyPolicyPage},

  { path: '/api-docs', name: 'apiDocs', component: ApiDocsPage },

  { path: '*', name: 'error404', component: Error404 },
]

const router = new VueRouter({
  routes,
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (from.name === to.name) {
      // no scroll if this is same page but different hash fragmetn
      // i.e. this prevents scroll when changing tabs at startup profile
    } else {
      return { x: 0, y: 0 }
    }
  },
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'vestbee'
  next()
})

export default router
window.router = router
